import React from 'react';
import { AlertList } from './AlertList';
import { ScrollToTop } from './ScrollToTop';

interface AssignedAlertsProps {
  setAssignedCountOverride: (count: number) => void;
}

const AssignedAlerts: React.FC<AssignedAlertsProps> = ({ setAssignedCountOverride }) => {
  return (
    <div className="relative">
      <AlertList type="assigned" onCountChange={setAssignedCountOverride} />
      <ScrollToTop />
    </div>
  );
};

export default AssignedAlerts;